/* === UTILITY FUNCTIONS === */
function formatMoney(cents) {
  try {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency', currency: currency, minimumFractionDigits: 2
    }).format(cents / 100);
  } catch (e) { return '$' + (cents / 100).toFixed(2); }
}

function esc(str) {
  return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}


/* === STICKY HEADER SCROLL SHADOW === */
(function () {
  var header = document.querySelector('.site-header');
  if (!header) return;
  window.addEventListener('scroll', function () {
    header.classList.toggle('is-scrolled', window.scrollY > 30);
  }, { passive: true });
})();


/* === AJAX ADD TO CART === */
(function () {
  var addToCartForm = document.getElementById('add-to-cart-form');
  var addToCartBtn  = document.getElementById('add-to-cart-btn');
  if (!addToCartForm || !addToCartBtn) return;

  var originalLabel = addToCartBtn.getAttribute('data-atc-label') || addToCartBtn.textContent.trim();

  addToCartForm.addEventListener('submit', function (e) {
    e.preventDefault();

    var variantInput = document.getElementById('selected-variant-id');
    var variantId    = variantInput ? variantInput.value : new FormData(addToCartForm).get('id');

    if (!variantId) {
      addToCartBtn.textContent = 'SELECT A SIZE';
      setTimeout(function () { addToCartBtn.textContent = originalLabel; }, 2000);
      return;
    }

    /* Build the cart payload — bundle tiers add multiple line items */
    var bundleQty = window.SNS_bundleQty ? window.SNS_bundleQty() : 1;

    if (bundleQty > 1 && window.SNS_bundleReady && !window.SNS_bundleReady()) {
      addToCartBtn.textContent = 'CHOOSE YOUR TEES';
      setTimeout(function () { addToCartBtn.textContent = originalLabel; }, 2000);
      return;
    }

    var payload;
    if (bundleQty > 1) {
      var items = [{ id: parseInt(variantId, 10), quantity: 1 }];
      var extras = window.SNS_bundleExtraItems ? window.SNS_bundleExtraItems() : [];
      extras.forEach(function (id) {
        items.push({ id: parseInt(id, 10), quantity: 1 });
      });
      payload = { items: items };
    } else {
      payload = { id: parseInt(variantId, 10), quantity: 1 };
    }

    addToCartBtn.disabled    = true;
    addToCartBtn.textContent = '. . .';

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify(payload)
    })
      .then(function (res) {
        if (!res.ok) throw new Error('failed');
        return res.json();
      })
      .then(function () {
        addToCartBtn.textContent = 'ADDED ✓';
        updateCartCount();
        setTimeout(function () {
          if (window.openCartDrawer) window.openCartDrawer();
        }, 300);
        setTimeout(function () {
          addToCartBtn.textContent = originalLabel;
          addToCartBtn.disabled    = false;
        }, 2200);
      })
      .catch(function () {
        addToCartBtn.textContent = 'TRY AGAIN';
        addToCartBtn.disabled    = false;
        setTimeout(function () {
          addToCartBtn.textContent = originalLabel;
        }, 2200);
      });
  });
})();


/* === BUY MORE — SAVE MORE BUNDLE === */
(function () {
  var bundle = document.getElementById('product-bundle');
  if (!bundle) return;

  var current   = window.SNS_CURRENT_PRODUCT || null;
  var catalog   = window.SNS_BUNDLE_PRODUCTS || [];
  var activeQty = 1;
  var activeRow = null;
  var autoPrice = bundle.getAttribute('data-bundle-auto') === '1';

  /* Map every known variant id -> price (cents) so bundle totals can reflect
     the ACTUAL products chosen, not just the main product's price. */
  var priceMap = {};
  function indexVariants(p) {
    (p && p.variants || []).forEach(function (v) { priceMap[String(v.id)] = v.price; });
  }
  indexVariants(current);
  catalog.forEach(indexVariants);

  /* The main (viewed) product's currently-selected variant price, in cents.
     Kept in sync when the shopper changes the main product's size/variant. */
  var currentUnitCents = parseInt(bundle.getAttribute('data-unit-price') || '0', 10);

  /* Recalculate tier prices. Each tier = the main product + its chosen extras,
     summed at their real prices, then the tier discount applied. */
  function updatePrices(unitCents) {
    if (unitCents) currentUnitCents = unitCents;
    if (!autoPrice || !currentUnitCents) return;
    bundle.querySelectorAll('[data-bundle-tier]').forEach(function (tier) {
      var qty     = parseInt(tier.getAttribute('data-bundle-qty') || '1', 10);
      var tierPct = parseInt(tier.getAttribute('data-bundle-tier-pct') || '0', 10);
      /* Start with the main product, then add each extra row's chosen variant.
         If a row hasn't been chosen yet, fall back to the main unit price. */
      var total = currentUnitCents;
      tier.querySelectorAll('[data-bundle-extra-row]').forEach(function (row) {
        var vid = row.getAttribute('data-variant-id');
        var pc  = (vid && priceMap[vid] != null) ? priceMap[vid] : currentUnitCents;
        total += pc;
      });
      var price   = Math.round(total * (100 - tierPct) / 100);
      var save    = total - price;
      var priceEl = tier.querySelector('.bundle-tier__price');
      var cmpEl   = tier.querySelector('.bundle-tier__compare');
      var subEl   = tier.querySelector('.bundle-tier__subtext');
      if (priceEl) priceEl.textContent = formatMoney(price);
      if (qty > 1) {
        if (cmpEl) { cmpEl.textContent = formatMoney(total); cmpEl.style.display = ''; }
        if (subEl) subEl.textContent = 'Save ' + formatMoney(save) + ' (' + tierPct + '% off)';
      }
    });
  }
  window.SNS_updateBundlePrices = updatePrices;

  /* Distinct sizes for a product (size option, else variant title) */
  function sizesOf(p) {
    var idx = 0;
    (p.options || []).forEach(function (o, i) {
      if (String(o).toLowerCase() === 'size') idx = i;
    });
    var seen = {}, out = [];
    (p.variants || []).forEach(function (v) {
      var label = (v.options && v.options[idx] != null) ? v.options[idx] : v.title;
      /* Products with no size options have a single "Default Title" variant —
         show a clean "One Size" label instead of "Default Title". */
      if (label && String(label).toLowerCase() === 'default title') label = 'One Size';
      if (seen[label] !== undefined) return;
      seen[label] = 1;
      out.push({ label: label, id: v.id, available: v.available });
    });
    return out;
  }

  /* Populate an extra-tee row with a product + its size buttons */
  function renderRow(row, p) {
    if (!p) return;
    row.setAttribute('data-product-id', p.id);
    var thumb = row.querySelector('[data-bundle-thumb]');
    var name  = row.querySelector('[data-bundle-name]');
    var wrap  = row.querySelector('[data-bundle-sizes]');
    if (thumb) { thumb.src = p.image || ''; thumb.alt = p.title || ''; }
    if (name)  name.textContent = p.title || '';

    var sizes = sizesOf(p);
    var html = '';
    sizes.forEach(function (s) {
      html += '<button type="button" class="bundle-size-btn" data-bundle-size-btn'
        + ' data-variant-id="' + s.id + '"'
        + (s.available ? '' : ' disabled aria-disabled="true"') + '>' + esc(s.label) + '</button>';
    });
    if (wrap) wrap.innerHTML = html;

    /* Auto-select the first available size so the bundle is ready by default */
    row.setAttribute('data-variant-id', '');
    var first = wrap ? wrap.querySelector('[data-bundle-size-btn]:not([disabled])') : null;
    if (first) {
      first.classList.add('is-selected');
      row.setAttribute('data-variant-id', first.getAttribute('data-variant-id'));
    }
  }

  function selectSize(row, btn) {
    row.querySelectorAll('[data-bundle-size-btn]').forEach(function (b) {
      b.classList.remove('is-selected');
    });
    btn.classList.add('is-selected');
    row.setAttribute('data-variant-id', btn.getAttribute('data-variant-id'));
    updatePrices();
  }

  function openPicker(row) {
    activeRow = row;
    var grid = bundle.querySelector('[data-bundle-picker-grid]');
    if (grid && !grid.getAttribute('data-filled')) {
      var html = '';
      catalog.forEach(function (p) {
        html += '<button type="button" class="bundle-picker__card" data-bundle-pick="' + p.id + '">'
          + '<img src="' + (p.image || '') + '" alt="" loading="lazy" width="120" height="150">'
          + '<span>' + esc(p.title) + '</span></button>';
      });
      grid.innerHTML = html;
      grid.setAttribute('data-filled', '1');
    }
    var panel = bundle.querySelector('[data-bundle-picker]');
    if (panel) panel.hidden = false;
  }

  function closePicker() {
    var panel = bundle.querySelector('[data-bundle-picker]');
    if (panel) panel.hidden = true;
    activeRow = null;
  }

  function pickProduct(id) {
    var chosen = null;
    for (var i = 0; i < catalog.length; i++) {
      if (String(catalog[i].id) === String(id)) { chosen = catalog[i]; break; }
    }
    if (chosen && activeRow) renderRow(activeRow, chosen);
    closePicker();
    updatePrices();
  }

  function selectTier(tier) {
    bundle.querySelectorAll('[data-bundle-tier]').forEach(function (t) {
      t.classList.remove('is-selected');
      var extras = t.querySelector('[data-bundle-extras]');
      if (extras) extras.hidden = true;
      var radio = t.querySelector('.bundle-tier__radio');
      if (radio) radio.checked = false;
    });
    tier.classList.add('is-selected');
    var radio = tier.querySelector('.bundle-tier__radio');
    if (radio) radio.checked = true;
    var extras = tier.querySelector('[data-bundle-extras]');
    if (extras) extras.hidden = false;
    activeQty = parseInt(tier.getAttribute('data-bundle-qty') || '1', 10);
    closePicker();
  }

  bundle.addEventListener('click', function (e) {
    var pickCard = e.target.closest('[data-bundle-pick]');
    if (pickCard) { pickProduct(pickCard.getAttribute('data-bundle-pick')); return; }

    if (e.target.closest('[data-bundle-picker-close]')) { closePicker(); return; }

    var change = e.target.closest('[data-bundle-change]');
    if (change) { openPicker(change.closest('[data-bundle-extra-row]')); return; }

    var sizeBtn = e.target.closest('[data-bundle-size-btn]:not([disabled])');
    if (sizeBtn) { selectSize(sizeBtn.closest('[data-bundle-extra-row]'), sizeBtn); return; }

    var tier = e.target.closest('[data-bundle-tier]');
    if (tier) selectTier(tier);
  });

  /* Initialise every extra row to the current product by default */
  bundle.querySelectorAll('[data-bundle-extra-row]').forEach(function (row) {
    renderRow(row, current);
  });

  /* Initial price calc from the embedded unit price */
  updatePrices(parseInt(bundle.getAttribute('data-unit-price') || '0', 10));

  /* Expose state to the ATC handler */
  window.SNS_bundleQty = function () { return activeQty; };

  window.SNS_bundleReady = function () {
    if (activeQty <= 1) return true;
    var tier = bundle.querySelector('[data-bundle-tier].is-selected');
    if (!tier) return true;
    var rows = tier.querySelectorAll('[data-bundle-extra-row]');
    for (var i = 0; i < rows.length; i++) {
      if (!rows[i].getAttribute('data-variant-id')) return false;
    }
    return true;
  };

  window.SNS_bundleExtraItems = function () {
    var ids = [];
    var tier = bundle.querySelector('[data-bundle-tier].is-selected');
    if (!tier || activeQty <= 1) return ids;
    tier.querySelectorAll('[data-bundle-extra-row]').forEach(function (row) {
      var id = row.getAttribute('data-variant-id');
      if (id) ids.push(id);
    });
    return ids;
  };

  /* Initialise from whichever tier is pre-selected (default) */
  var preselected = bundle.querySelector('[data-bundle-tier].is-selected')
    || bundle.querySelector('[data-bundle-tier]');
  if (preselected) selectTier(preselected);
})();


function updateCartCount() {
  fetch('/cart.js')
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = 'CART [' + cart.item_count + ']';
      });
      document.querySelectorAll('[data-cart-count-num]').forEach(function (el) {
        el.textContent = cart.item_count;
        if (cart.item_count > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
      });
    })
    .catch(function () {});
}


/* === VARIANT RESOLVER === */
(function () {
  var variants = window.SNS_VARIANTS;
  if (!variants) return;

  var selectedOptions = {};

  /* Pre-select first variant's options if there's only one variant */
  if (variants.length === 1) {
    variants[0].options.forEach(function (opt, i) {
      selectedOptions['option' + (i + 1)] = opt;
    });
  }

  function resolveVariant() {
    var matched = null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var allMatch = v.options.every(function (opt, idx) {
        var key = 'option' + (idx + 1);
        return !selectedOptions[key] || selectedOptions[key] === opt;
      });
      if (allMatch) { matched = v; break; }
    }
    if (!matched) return;

    var variantInput = document.getElementById('selected-variant-id');
    var priceEl      = document.getElementById('product-price');
    var compareEl    = document.getElementById('product-compare-price');
    var atcBtn       = document.getElementById('add-to-cart-btn');
    var urgencyEl    = document.getElementById('urgency-badge');
    var stickyVariant= document.getElementById('sticky-atc-variant');

    if (variantInput) variantInput.value = matched.id;

    if (priceEl) priceEl.textContent = formatMoney(matched.price);

    if (window.SNS_updateBundlePrices) window.SNS_updateBundlePrices(matched.price);

    if (compareEl) {
      if (matched.compare_at_price && matched.compare_at_price > matched.price) {
        compareEl.textContent  = formatMoney(matched.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }

    if (atcBtn) {
      var soldOutLabel = atcBtn.getAttribute('data-sold-out-label') || 'SOLD OUT';
      var atcLabel     = atcBtn.getAttribute('data-atc-label') || 'ADD TO CART';
      atcBtn.disabled  = !matched.available;
      atcBtn.textContent = matched.available ? atcLabel : soldOutLabel;
    }

    if (urgencyEl) {
      var threshold = parseInt(urgencyEl.getAttribute('data-threshold') || '5', 10);
      var urgencyText = document.getElementById('urgency-text');
      var urgencyFill = document.getElementById('urgency-fill');
      if (matched.inventory_management === 'shopify'
          && matched.inventory_quantity > 0
          && matched.inventory_quantity <= threshold) {
        var prefix = urgencyEl.getAttribute('data-prefix') || 'HURRY UP! ONLY';
        var suffix = urgencyEl.getAttribute('data-suffix') || 'ITEMS LEFT IN STOCK';
        if (urgencyText) {
          urgencyText.textContent = prefix + ' ' + matched.inventory_quantity + ' ' + suffix;
        }
        if (urgencyFill && threshold > 0) {
          var pct = Math.max(8, Math.round((matched.inventory_quantity / threshold) * 100));
          urgencyFill.style.width = pct + '%';
        }
        urgencyEl.style.display = '';
      } else {
        urgencyEl.style.display = 'none';
      }
    }

    /* Update sticky bar variant text */
    var sizePart  = selectedOptions['option1'] || selectedOptions['option2'] || '';
    var colorPart = selectedOptions['option2'] || selectedOptions['option3'] || '';
    if (stickyVariant) {
      stickyVariant.textContent = sizePart ? 'Size: ' + sizePart : 'Select a size';
    }
  }

  document.addEventListener('click', function (e) {
    /* Size button clicks */
    var sizeBtn = e.target.closest('.size-btn:not(:disabled)');
    if (sizeBtn) {
      var idx = sizeBtn.getAttribute('data-option-index') || '0';
      document.querySelectorAll('.size-btn[data-option-index="' + idx + '"]').forEach(function (b) {
        b.classList.remove('is-selected');
      });
      sizeBtn.classList.add('is-selected');
      selectedOptions['option' + (parseInt(idx, 10) + 1)] = sizeBtn.getAttribute('data-size');
      resolveVariant();
      return;
    }

    /* Color swatch clicks */
    var colorSwatch = e.target.closest('.color-swatch');
    if (colorSwatch) {
      document.querySelectorAll('.color-swatch').forEach(function (s) {
        s.classList.remove('is-selected');
      });
      colorSwatch.classList.add('is-selected');
      var colorIdx = colorSwatch.getAttribute('data-option-index') || '0';
      selectedOptions['option' + (parseInt(colorIdx, 10) + 1)] = colorSwatch.getAttribute('data-color-name');
      var colorLabelEl = document.querySelector('.color-label-display');
      if (colorLabelEl) colorLabelEl.textContent = colorSwatch.getAttribute('data-color-name');
      resolveVariant();
    }
  });

  /* Auto-resolve on load for single-variant products */
  if (variants.length === 1) resolveVariant();
})();


/* === SIZE CHART MODAL === */
(function () {
  var overlay   = document.getElementById('size-chart-overlay');
  var modal     = document.getElementById('size-chart-modal');
  var closeBtn  = document.getElementById('size-chart-close');
  var modalBody = document.getElementById('size-chart-body');
  var tmpl      = document.getElementById('size-chart-content');
  if (!modal) return;

  function openChart() {
    if (tmpl && modalBody) {
      modalBody.innerHTML = '';
      modalBody.appendChild(document.importNode(tmpl.content, true));
    }
    if (overlay) overlay.classList.add('is-open');
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeChart() {
    if (overlay) overlay.classList.remove('is-open');
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('.size-chart-link')) openChart();
  });
  if (closeBtn) closeBtn.addEventListener('click', closeChart);
  if (overlay)  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeChart();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeChart();
  });
})();


/* === CURRENCY PICKER === */
var CURRENCY_COUNTRY = {
  USD: 'us', CAD: 'ca', MXN: 'mx', BRL: 'br', ARS: 'ar',
  CLP: 'cl', COP: 'co', PEN: 'pe', UYU: 'uy', PYG: 'py',
  BOB: 'bo', VES: 've', GYD: 'gy', SRD: 'sr', TTD: 'tt',
  JMD: 'jm', BBD: 'bb', BSD: 'bs', BZD: 'bz', HTG: 'ht',
  HNL: 'hn', GTQ: 'gt', NIO: 'ni', CRC: 'cr', DOP: 'do',
  PAB: 'pa', AWG: 'aw', KYD: 'ky', XCD: 'ag', BMD: 'bm',
  EUR: 'eu', GBP: 'gb', CHF: 'ch', SEK: 'se', NOK: 'no',
  DKK: 'dk', PLN: 'pl', CZK: 'cz', HUF: 'hu', RON: 'ro',
  BGN: 'bg', HRK: 'hr', RSD: 'rs', ISK: 'is', UAH: 'ua',
  BAM: 'ba', MKD: 'mk', MDL: 'md', ALL: 'al', RUB: 'ru',
  GEL: 'ge', AMD: 'am', AZN: 'az', BYN: 'by', TRY: 'tr',
  AED: 'ae', SAR: 'sa', KWD: 'kw', QAR: 'qa', OMR: 'om',
  BHD: 'bh', JOD: 'jo', ILS: 'il', EGP: 'eg', MAD: 'ma',
  TND: 'tn', LYD: 'ly', DZD: 'dz', LBP: 'lb', IQD: 'iq',
  YER: 'ye', SYP: 'sy', SDG: 'sd',
  JPY: 'jp', CNY: 'cn', HKD: 'hk', SGD: 'sg', TWD: 'tw',
  KRW: 'kr', INR: 'in', PKR: 'pk', BDT: 'bd', LKR: 'lk',
  NPR: 'np', MYR: 'my', IDR: 'id', PHP: 'ph', THB: 'th',
  VND: 'vn', MMK: 'mm', KHR: 'kh', LAK: 'la', MNT: 'mn',
  KZT: 'kz', UZS: 'uz', KGS: 'kg', TMT: 'tm', AFN: 'af',
  AUD: 'au', NZD: 'nz', FJD: 'fj', PGK: 'pg', SBD: 'sb',
  TOP: 'to', VUV: 'vu', WST: 'ws', BTN: 'bt', MVR: 'mv', MOP: 'mo',
  ZAR: 'za', NGN: 'ng', KES: 'ke', GHS: 'gh', ETB: 'et',
  TZS: 'tz', UGX: 'ug', RWF: 'rw', MZN: 'mz', ZMW: 'zm',
  ZWL: 'zw', BWP: 'bw', NAD: 'na', SZL: 'sz', LSL: 'ls',
  MWK: 'mw', MGA: 'mg', MUR: 'mu', SCR: 'sc', CVE: 'cv',
  GMD: 'gm', SLL: 'sl', LRD: 'lr', DJF: 'dj', KMF: 'km',
  BIF: 'bi', CDF: 'cd', AOA: 'ao', SOS: 'so', MRO: 'mr',
  XAF: 'un', XOF: 'un'
};

function makeFlagEl(countryCode) {
  var span = document.createElement('span');
  span.className = 'fi fi-' + countryCode;
  return span;
}

function initCurrencyPicker() {
  var hiddenSelect = document.getElementById('currency-select-hidden');
  var btn          = document.getElementById('currency-picker-btn');
  var dropdown     = document.getElementById('currency-picker-dropdown');
  var flagSpan     = document.getElementById('currency-picker-flag');
  var codeSpan     = document.getElementById('currency-picker-code');
  if (!hiddenSelect || !btn || !dropdown) return;

  Array.from(hiddenSelect.options).forEach(function (option) {
    var code        = option.value.trim().toUpperCase();
    var countryCode = CURRENCY_COUNTRY[code];
    var item        = document.createElement('div');
    item.className  = 'currency-picker__option' + (option.selected ? ' is-active' : '');
    item.setAttribute('role', 'option');
    item.setAttribute('data-value', option.value);
    if (countryCode) item.appendChild(makeFlagEl(countryCode));
    item.appendChild(document.createTextNode(' ' + code));
    if (option.selected) {
      if (flagSpan && countryCode) {
        flagSpan.innerHTML = '';
        flagSpan.appendChild(makeFlagEl(countryCode));
      }
      if (codeSpan) codeSpan.textContent = ' ' + code;
    }
    item.addEventListener('click', function () {
      hiddenSelect.value = this.getAttribute('data-value');
      hiddenSelect.closest('form').submit();
    });
    dropdown.appendChild(item);
  });

  btn.addEventListener('click', function (e) {
    e.stopPropagation();
    var isOpen = dropdown.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });

  document.addEventListener('click', function () {
    dropdown.classList.remove('is-open');
    btn.setAttribute('aria-expanded', 'false');
  });
}

function initMobileCurrencyPicker() {
  var sel = document.getElementById('mobile-currency-select');
  if (!sel) return;
  sel.addEventListener('change', function () {
    var form = sel.closest('form');
    if (form) form.submit();
  });
}

document.addEventListener('DOMContentLoaded', initCurrencyPicker);
document.addEventListener('DOMContentLoaded', initMobileCurrencyPicker);


/* === FLASH SALE COUNTDOWN === */
(function () {
  var el = document.getElementById('announcement-countdown');
  if (!el) return;

  var hoursEl = document.getElementById('cd-hours');
  var minsEl  = document.getElementById('cd-mins');
  var secsEl  = document.getElementById('cd-secs');
  var bar     = document.getElementById('flash-sale-bar');

  var isLoop = el.dataset.loop === 'true';
  var endTime;

  function nextBoundary() {
    var now  = new Date();
    var next = new Date(now);
    if (now.getHours() < 12) {
      next.setHours(12, 0, 0, 0);
    } else {
      next.setDate(next.getDate() + 1);
      next.setHours(0, 0, 0, 0);
    }
    return next.getTime();
  }

  if (isLoop) {
    endTime = nextBoundary();
  } else {
    var endStr = el.dataset.end;
    if (!endStr) return;
    endTime = new Date(endStr).getTime();
    if (isNaN(endTime)) return;
  }

  function pad(n) { return String(n).padStart(2, '0'); }

  function tick() {
    var diff = endTime - Date.now();
    if (diff <= 0) {
      if (isLoop) {
        endTime = nextBoundary();
        diff = endTime - Date.now();
      } else {
        if (bar) bar.style.display = 'none';
        return;
      }
    }
    var h = Math.floor(diff / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    if (hoursEl) hoursEl.textContent = pad(h);
    if (minsEl)  minsEl.textContent  = pad(m);
    if (secsEl)  secsEl.textContent  = pad(s);
  }

  tick();
  setInterval(tick, 1000);
}());


/* === MOBILE MENU === */
(function () {
  var hamburger   = document.getElementById('hamburger');
  var mobileNav   = document.getElementById('mobile-nav');
  var mobileClose = document.getElementById('mobile-nav-close');
  if (!hamburger || !mobileNav) return;

  hamburger.addEventListener('click', function () {
    var isOpen = mobileNav.classList.toggle('is-open');
    hamburger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    document.body.style.overflow = isOpen ? 'hidden' : '';
  });

  if (mobileClose) {
    mobileClose.addEventListener('click', function () {
      mobileNav.classList.remove('is-open');
      hamburger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    });
  }
})();


/* === CONTACT DRAWER === */
(function () {
  var openBtn   = document.getElementById('contact-drawer-open');
  var mobileBtn = document.getElementById('contact-drawer-open-mobile');
  var drawer    = document.getElementById('contact-drawer');
  var overlay   = document.getElementById('contact-overlay');
  var closeBtn  = document.getElementById('contact-drawer-close');
  if (!drawer) return;

  function openDrawer() {
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (openBtn)   openBtn.addEventListener('click', openDrawer);
  if (mobileBtn) mobileBtn.addEventListener('click', function () {
    var nav = document.getElementById('mobile-nav');
    var hbg = document.getElementById('hamburger');
    if (nav) nav.classList.remove('is-open');
    if (hbg) hbg.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    setTimeout(openDrawer, 50);
  });
  if (closeBtn)  closeBtn.addEventListener('click', closeDrawer);
  if (overlay)   overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeDrawer();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });
})();


/* === REVIEWS SLIDER === */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-reviews-prev], [data-reviews-next]');
  if (!btn) return;
  var section = btn.closest('.reviews-section');
  if (!section) return;
  var track = section.querySelector('[data-reviews-track]');
  if (!track) return;
  var card   = track.querySelector('.review-card');
  var amount = card ? card.offsetWidth + 24 : 344;
  if (btn.hasAttribute('data-reviews-prev')) {
    track.scrollBy({ left: -amount, behavior: 'smooth' });
  } else {
    track.scrollBy({ left: amount, behavior: 'smooth' });
  }
});


/* === CART DRAWER === */
(function () {
  var openBtnDesktop = document.getElementById('cart-drawer-open');
  var openBtnMobile  = document.getElementById('cart-drawer-open-mobile');
  var drawer         = document.getElementById('cart-drawer');
  var overlay        = document.getElementById('cart-overlay');
  var closeBtn       = document.getElementById('cart-drawer-close');
  var body           = document.getElementById('cart-drawer-body');
  var footer         = document.getElementById('cart-drawer-footer');
  if (!drawer) return;

  function openCartDrawer() {
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    loadCart();
  }

  function closeCartDrawer() {
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (openBtnDesktop) openBtnDesktop.addEventListener('click', openCartDrawer);
  if (openBtnMobile)  openBtnMobile.addEventListener('click', function () {
    var nav = document.getElementById('mobile-nav');
    var hbg = document.getElementById('hamburger');
    if (nav) nav.classList.remove('is-open');
    if (hbg) hbg.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    setTimeout(openCartDrawer, 60);
  });
  if (closeBtn) closeBtn.addEventListener('click', closeCartDrawer);
  if (overlay)  overlay.addEventListener('click', closeCartDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeCartDrawer();
  });

  function loadCart() {
    if (!body) return;
    body.innerHTML = '<div class="cart-drawer__loading">—</div>';
    if (footer) footer.style.display = 'none';
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) { renderCart(cart); })
      .catch(function () {
        if (body) body.innerHTML = '<div class="cart-drawer__loading">Could not load cart.</div>';
      });
  }

  function renderCart(cart) {
    if (!body) return;
    if (cart.item_count === 0) {
      var shopUrl = (drawer && drawer.getAttribute('data-empty-shop-url')) || '/collections/all';
      body.innerHTML =
        '<div class="cart-drawer__empty">' +
        '<p>YOUR CART IS EMPTY</p>' +
        '<p style="font-size:0.8rem;color:var(--muted);margin:0.5rem 0 1.5rem;">Time to fix that.</p>' +
        '<a href="' + shopUrl + '" class="btn btn--outline">SHOP NOW</a>' +
        '</div>';
      if (footer) footer.style.display = 'none';
      return;
    }
    var html = '<ul class="cart-drawer__items">';
    cart.items.forEach(function (item) {
      var imgHtml = item.image
        ? '<img class="cart-drawer__item-img" src="' + item.image + '" alt="' + esc(item.title) + '" loading="lazy" width="80" height="100">'
        : '<div class="cart-drawer__item-img-placeholder"></div>';
      var variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<span class="cart-drawer__item-variant">' + esc(item.variant_title) + '</span>'
        : '';
      html +=
        '<li class="cart-drawer__item">' +
        imgHtml +
        '<div class="cart-drawer__item-info">' +
        '<span class="cart-drawer__item-title">' + esc(item.product_title || item.title) + '</span>' +
        variantHtml +
        '<span class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</span>' +
        '<div class="cart-drawer__item-controls">' +
        '<div class="cart-drawer__qty">' +
        '<button class="cart-drawer__qty-btn" data-cart-qty data-key="' + item.key + '" data-delta="-1" type="button" aria-label="Decrease">&#8722;</button>' +
        '<span class="cart-drawer__qty-val">' + item.quantity + '</span>' +
        '<button class="cart-drawer__qty-btn" data-cart-qty data-key="' + item.key + '" data-delta="1" type="button" aria-label="Increase">+</button>' +
        '</div>' +
        '<button class="cart-drawer__item-remove" data-cart-remove data-key="' + item.key + '" type="button">REMOVE</button>' +
        '</div></div></li>';
    });
    html += '</ul>';
    body.innerHTML = html;
    if (footer) {
      footer.style.display = '';
      var subtotalEl = footer.querySelector('[data-cart-subtotal]');
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    }
  }

  document.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('[data-cart-qty]');
    if (qtyBtn && drawer.contains(qtyBtn)) {
      var key    = qtyBtn.getAttribute('data-key');
      var delta  = parseInt(qtyBtn.getAttribute('data-delta'), 10);
      var valEl  = qtyBtn.parentElement.querySelector('.cart-drawer__qty-val');
      var newQty = Math.max(0, parseInt(valEl ? valEl.textContent : 1, 10) + delta);
      updateLineItem(key, newQty);
      return;
    }
    var removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn && drawer.contains(removeBtn)) {
      updateLineItem(removeBtn.getAttribute('data-key'), 0);
    }
  });

  function updateLineItem(key, qty) {
    fetch('/cart/change.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) { updateCartCount(); renderCart(cart); })
      .catch(function () {});
  }

  window.openCartDrawer = openCartDrawer;
})();


/* === PRODUCT IMAGE GALLERY === */
(function () {
  var mainImg = document.getElementById('product-gallery-main');
  if (!mainImg) return;
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-src]');
    if (!thumb) return;
    document.querySelectorAll('[data-gallery-src]').forEach(function (t) {
      t.classList.remove('is-active');
    });
    thumb.classList.add('is-active');
    mainImg.style.opacity = '0';
    setTimeout(function () {
      mainImg.src = thumb.getAttribute('data-gallery-src');
      mainImg.alt = thumb.getAttribute('data-gallery-alt') || '';
      mainImg.style.opacity = '1';
    }, 160);
  });
})();


/* === STICKY ATC BAR === */
(function () {
  var stickyBar  = document.getElementById('sticky-atc');
  var mainAtcBtn = document.getElementById('add-to-cart-btn');
  var stickyBtn  = document.getElementById('sticky-atc-btn');
  if (!stickyBar || !mainAtcBtn) return;

  function onScroll() {
    var rect      = mainAtcBtn.getBoundingClientRect();
    var outOfView = rect.bottom < 0 || rect.top > window.innerHeight;
    stickyBar.classList.toggle('is-visible', outOfView);
    stickyBar.setAttribute('aria-hidden', outOfView ? 'false' : 'true');
  }

  window.addEventListener('scroll', onScroll, { passive: true });

  if (stickyBtn) {
    stickyBtn.addEventListener('click', function () {
      var form = document.getElementById('add-to-cart-form');
      if (form) form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    });
  }
})();


/* === QUICK-ADD FROM PRODUCT CARDS === */
(function () {
  var activePopover = null;

  document.addEventListener('click', function (e) {
    var quickAddBtn = e.target.closest('[data-quick-add]');
    if (quickAddBtn) {
      e.preventDefault();
      var variantId = quickAddBtn.getAttribute('data-variant-id');
      var handle    = quickAddBtn.getAttribute('data-handle');
      if (variantId) {
        quickAddDirect(parseInt(variantId, 10), quickAddBtn);
      } else if (handle) {
        openSizePicker(handle, quickAddBtn);
      }
      return;
    }

    /* Close popover when clicking outside */
    if (activePopover && !e.target.closest('.quick-add-popover') && !e.target.closest('[data-quick-add]')) {
      closePopover();
    }

    /* Size selection inside popover */
    var popoverSizeBtn = e.target.closest('.quick-add-popover__size-btn');
    if (popoverSizeBtn) {
      var vid = parseInt(popoverSizeBtn.getAttribute('data-variant-id'), 10);
      quickAddDirect(vid, popoverSizeBtn);
      closePopover();
      return;
    }

    /* Close button inside popover */
    if (e.target.closest('.quick-add-popover__close')) {
      closePopover();
    }
  });

  function quickAddDirect(variantId, btn) {
    var origText = btn.textContent;
    btn.textContent = '. . .';
    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (res) { if (!res.ok) throw new Error(); return res.json(); })
      .then(function () {
        btn.textContent = 'ADDED ✓';
        updateCartCount();
        setTimeout(function () { if (window.openCartDrawer) window.openCartDrawer(); }, 400);
        setTimeout(function () { btn.textContent = origText; }, 2000);
      })
      .catch(function () { btn.textContent = origText; });
  }

  function openSizePicker(handle, triggerBtn) {
    closePopover();
    var card = triggerBtn.closest('.product-card');
    if (!card) return;
    fetch('/products/' + handle + '.js')
      .then(function (res) { return res.json(); })
      .then(function (product) {
        var sizeOptIdx = product.options.findIndex(function (o) {
          return o.toLowerCase() === 'size';
        });
        var shownSizes = [];
        var html = '<button class="quick-add-popover__close" type="button" aria-label="Close">✕</button>';
        html += '<span class="quick-add-popover__label">SELECT SIZE</span>';
        html += '<div class="quick-add-popover__sizes">';
        product.variants.forEach(function (v) {
          var size = sizeOptIdx >= 0 ? v.options[sizeOptIdx] : v.title;
          if (shownSizes.indexOf(size) > -1) return;
          shownSizes.push(size);
          html += '<button class="quick-add-popover__size-btn"' +
            ' data-variant-id="' + v.id + '"' +
            (v.available ? '' : ' disabled style="opacity:0.35;"') + '>' +
            esc(size) + '</button>';
        });
        html += '</div>';
        var popover = document.createElement('div');
        popover.className = 'quick-add-popover is-open';
        popover.innerHTML = html;
        card.style.position = 'relative';
        card.appendChild(popover);
        activePopover = popover;
      })
      .catch(function () {});
  }

  function closePopover() {
    if (activePopover) {
      activePopover.remove();
      activePopover = null;
    }
  }
})();


/* === NEWSLETTER FORM === */
(function () {
  document.querySelectorAll('#newsletter-form').forEach(function (form) {
    var formFields = form.querySelector('.newsletter__form') || form;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!form.checkValidity()) { form.reportValidity(); return; }
      fetch(form.action || '/contact', {
        method:      'POST',
        body:        new FormData(form),
        credentials: 'same-origin',
        headers:     { 'Accept': 'text/html' }
      }).then(function (res) {
        if (!res.ok && !res.redirected) throw new Error();
        form.reset();
        var fields  = form.querySelector('.newsletter__form');
        var success = document.getElementById('newsletter-success');
        if (fields)  fields.style.display  = 'none';
        if (success) success.style.display = 'block';
      }).catch(function () { form.submit(); });
    });
  });
})();


/* === PRODUCT CAROUSEL === */
(function () {
  document.addEventListener('click', function (e) {
    var arrow = e.target.closest('.product-carousel__arrow');
    if (!arrow) return;
    var carousel = arrow.closest('.product-carousel');
    if (!carousel) return;
    var track = carousel.querySelector('.product-carousel__track');
    if (!track) return;
    var item  = track.querySelector('.product-carousel__item');
    var width = item ? (item.offsetWidth + parseInt(getComputedStyle(track).gap || 0, 10)) : 280;
    var dir   = arrow.classList.contains('product-carousel__arrow--next') ? 1 : -1;
    track.scrollBy({ left: dir * width, behavior: 'smooth' });
  });
})();


/* === COLLECTION SORT === */
(function () {
  var sortSelect = document.querySelector('[data-collection-sort]');
  if (!sortSelect) return;
  sortSelect.addEventListener('change', function () {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', this.value);
    window.location.href = url.toString();
  });
})();


/* === EMAIL POPUP === */
(function () {
  var STORAGE_KEY = 'larpparel_popup_seen';
  var DELAY_MS    = 5000;

  if (localStorage.getItem(STORAGE_KEY)) return;

  var overlay  = document.getElementById('email-popup-overlay');
  var closeBtn = document.getElementById('email-popup-close');
  var skipBtn  = document.getElementById('email-popup-skip');
  var form     = document.getElementById('email-popup-form');
  var success  = document.getElementById('email-popup-success');
  if (!overlay) return;

  function openPopup() {
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
  }

  function closePopup() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    localStorage.setItem(STORAGE_KEY, '1');
  }

  setTimeout(openPopup, DELAY_MS);

  if (closeBtn) closeBtn.addEventListener('click', closePopup);
  if (skipBtn)  skipBtn.addEventListener('click', closePopup);

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closePopup();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) closePopup();
  });

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var emailInput = form.querySelector('input[type="email"]');
      if (!emailInput || !emailInput.validity.valid) {
        if (emailInput) emailInput.focus();
        return;
      }
      var submitBtn = form.querySelector('button[type="submit"]');
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = '—'; }
      var body = new FormData();
      body.append('form_type', 'customer');
      body.append('utf8', '✓');
      body.append('contact[email]', emailInput.value);
      body.append('contact[tags]', 'newsletter,popup');
      fetch('/contact', {
        method:      'POST',
        body:        body,
        credentials: 'same-origin',
        headers:     { 'Accept': 'text/html' }
      }).finally(function () {
        if (form)    form.style.display    = 'none';
        if (success) success.style.display = 'block';
        localStorage.setItem(STORAGE_KEY, '1');
      });
    });
  }
})();


/* === SEARCH OVERLAY (drops down from top) === */
(function () {
  var btn     = document.getElementById('mobile-search-btn');
  var overlay = document.getElementById('search-overlay');
  var input   = document.getElementById('mobile-search-input');
  if (!btn || !overlay) return;

  function openSearch() {
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    btn.setAttribute('aria-expanded', 'true');
    document.body.classList.add('search-open');
    if (input) setTimeout(function () { input.focus(); }, 120);
  }

  function closeSearch() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    btn.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('search-open');
  }

  btn.addEventListener('click', function (e) {
    e.stopPropagation();
    if (overlay.classList.contains('is-open')) { closeSearch(); } else { openSearch(); }
  });

  overlay.querySelectorAll('[data-search-close]').forEach(function (el) {
    el.addEventListener('click', closeSearch);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeSearch();
  });
})();
